import { render } from "./WinckieelIntelligence.vue?vue&type=template&id=50ba8636&scoped=true"
import script from "./WinckieelIntelligence.vue?vue&type=script&lang=js"
export * from "./WinckieelIntelligence.vue?vue&type=script&lang=js"

import "./WinckieelIntelligence.vue?vue&type=style&index=0&id=50ba8636&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50ba8636"]])

export default __exports__